(function () {
  'use strict';
  const MINIMUM_ORDER_CENTS = 10000;
  const KEY = 'smg-cart-v1';
  const PENDING_KEY = 'smg-order-pending-v1';
  const DONE_KEY = 'smg-order-done-v1';
  let submitting = false;
  const byId = id => document.getElementById(id);
  const view = byId('smg-cart-view');
  const money = value => new Intl.NumberFormat('nl-NL', {style:'currency', currency:'EUR'}).format(value);
  let lines = [];
  let removedLoosePacks = false;
  let removedSoldOut = false;
  const packDefinitions = {
    'SM-001': {count:6, sizes:{S:2, M:2, L:2}, ratio:'2×S · 2×M · 2×L'},
    'SM-002': {count:6, sizes:{'S/M':3, 'M/L':3}, ratio:'3×S/M · 3×M/L'},
    'SM-004': {count:10, sizes:{XS:1, S:3, M:3, L:2, XL:1}, ratio:'1×XS · 3×S · 3×M · 2×L · 1×XL'},
    'SM-007': {count:6, sizes:{S:2, M:2, L:2}, ratio:'2×S · 2×M · 2×L'},
    'SM-026': {count:6, sizes:{'S/M':3, 'M/L':3}, ratio:'3×S/M · 3×M/L'}
  };
  const packFor = line => line && packDefinitions[line.article];
  const isFixedPack = line => Boolean(packFor(line));
  function validFixedPack(line) {
    const pack = packFor(line);
    if (!pack) return true;
    const amounts = Object.entries(pack.sizes).map(([size, count]) => Number(line.sizes && line.sizes[size] || 0) / count);
    return Object.keys(line.sizes || {}).every(size => size in pack.sizes)
      && amounts.every(value => Number.isInteger(value) && value > 0 && value === amounts[0])
      && line.total === amounts[0] * pack.count;
  }

  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function load() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(KEY));
      lines = Array.isArray(stored) ? stored.filter(line => {
        if (!line || !line.sizes || line.total <= 0) return false;
        if (line.article === 'SM-006') { removedSoldOut = true; return false; }
        if (!validFixedPack(line)) { removedLoosePacks = true; return false; }
        return true;
      }) : [];
    } catch {
      lines = [];
    }
  }

  function save() {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(lines));
    } catch {
      /* privémodus: de winkelwagen bestaat dan alleen in deze sessie */
    }
  }

  function pieces() {
    return lines.reduce((sum, line) => sum + line.total, 0);
  }

  /* Prijs is optioneel: demo-artikelen hebben er nog geen. We tonen een
     prijstotaal alleen als ELKE regel een prijs heeft — een gedeeltelijk
     totaal ("5 van de 8 artikelen geprijsd") is verwarrender dan geen totaal. */
  function priceTotal() {
    if (!lines.length || !lines.every(line => typeof line.price === 'number')) return null;
    return lines.reduce((sum, line) => sum + (line.price * line.total), 0);
  }

  function minimumMessage(total) {
    if (total === null) return 'Minimale bestelwaarde: € 100 excl. btw. Een artikelprijs ontbreekt; bestellen is tijdelijk niet mogelijk.';
    const cents = Math.round(total * 100);
    if (cents < MINIMUM_ORDER_CENTS) return 'Minimale bestelwaarde: € 100 excl. btw. Voeg nog ' + money((MINIMUM_ORDER_CENTS - cents) / 100) + ' toe om te bestellen.';
    return 'Minimale bestelwaarde van € 100 excl. btw bereikt.';
  }

  function updateMinimum() {
    const total = priceTotal();
    const eligible = total !== null && Math.round(total * 100) >= MINIMUM_ORDER_CENTS;
    const notice = byId('smg-cart-minimum');
    const button = byId('smg-cart-submit');
    if (notice) notice.textContent = lines.length ? minimumMessage(total) : '';
    if (button) button.disabled = !lines.length || !eligible || submitting;
    return eligible;
  }

  function updateBadge() {
    const total = pieces();
    document.querySelectorAll('[data-cart-count]').forEach(element => {
      element.textContent = total;
      element.hidden = total === 0;
    });
  }

  load();
  if (removedLoosePacks || removedSoldOut) save();
  updateBadge();

  /* De homepage heeft wel de knop in de header, maar niet de winkelwagen zelf.
     Daar werken we alleen de teller bij en stoppen we hier. */
  if (!view) return;

  const isDemo = view.dataset.cartDemo === 'true';
  const form = byId('B2BOrderForm');
  const formState = byId('B2BOrderFormState');

  function renderLines() {
    const fragment = document.createDocumentFragment();
    lines.forEach(line => {
      const item = node('li', 'smg-cart-line');
      const photo = node('div', 'smg-cart-line__photo');
      if (line.image) {
        const image = document.createElement('img');
        image.src = line.image;
        image.alt = line.name;
        image.width = 88;
        image.height = 110;
        image.loading = 'lazy';
        photo.append(image);
      }

      const body = node('div', 'smg-cart-line__body');
      body.append(node('h2', '', line.name));
      body.append(node('p', 'smg-cart-line__meta', line.article + ' · ' + line.color));

      const sizes = node('ul', 'smg-cart-line__sizes');
      const editableSizes = isFixedPack(line) ? [['__pack', line.total / packFor(line).count]] : Object.entries(line.sizes);
      editableSizes.forEach(([size, quantity]) => {
        const chip = node('li', 'smg-cart-line__size');
        const label = node('label', '', isFixedPack(line) ? 'Pakketten (' + packFor(line).ratio + ')' : 'Maat ' + size);
        const quantityInput = document.createElement('input');
        quantityInput.className = 'smg-cart-line__quantity';
        quantityInput.type = 'number';
        quantityInput.min = '0';
        quantityInput.max = isFixedPack(line) ? String(Math.floor(999 / Math.max(...Object.values(packFor(line).sizes)))) : '999';
        quantityInput.step = '1';
        quantityInput.inputMode = 'numeric';
        quantityInput.value = String(quantity);
        quantityInput.dataset.quantityKey = line.key;
        quantityInput.dataset.quantitySize = size;
        quantityInput.setAttribute('aria-label', isFixedPack(line) ? 'Aantal pakketten van ' + packFor(line).count + ' stuks van ' + line.name : 'Aantal voor maat ' + size + ' van ' + line.name);
        label.append(quantityInput);
        chip.append(label);
        if (line.variantSkus && line.variantSkus[size]) chip.append(node('span', '', line.variantSkus[size]));
        sizes.append(chip);
      });
      body.append(sizes);
      if (typeof line.price === 'number') {
        body.append(node('p', 'smg-cart-line__sub', (isFixedPack(line) ? (line.total / packFor(line).count) + ' pakketten · ' : '') + line.total + ' stuks · ' + money(line.price) + ' per stuk excl. btw · ' + money(line.price * line.total) + ' excl. btw'));
      } else {
        body.append(node('p', 'smg-cart-line__sub', line.total + ' stuks'));
      }

      const remove = node('button', 'smg-cart-line__remove', 'Verwijderen');
      remove.type = 'button';
      remove.dataset.remove = line.key;
      remove.setAttribute('aria-label', 'Verwijder ' + line.name + ' uit je winkelwagen');

      item.append(photo, body, remove);
      fragment.append(item);
    });
    byId('smg-cart-lines').replaceChildren(fragment);
    byId('smg-cart-total').textContent = pieces() + ' stuks';
    const priceRow = byId('smg-cart-price-total');
    const total = priceTotal();
    if (priceRow) {
      priceRow.hidden = total === null;
      if (total !== null) byId('smg-cart-price-total-value').textContent = money(total);
    }
    byId('smg-cart-empty').hidden = lines.length > 0;
    byId('smg-cart-filled').hidden = lines.length === 0;
    updateMinimum();
  }

  function add(detail) {
    if (!detail || !detail.id || !detail.sizes || detail.article === 'SM-006' || !validFixedPack(detail)) return;
    const key = detail.id + '|' + detail.color;
    const existing = lines.find(line => line.key === key);
    if (existing) {
      Object.entries(detail.sizes).forEach(([size, quantity]) => {
        existing.sizes[size] = (existing.sizes[size] || 0) + quantity;
      });
      existing.variantIds = Object.assign(existing.variantIds || {}, detail.variantIds || {});
      existing.variantSkus = Object.assign(existing.variantSkus || {}, detail.variantSkus || {});
      existing.total = Object.values(existing.sizes).reduce((sum, quantity) => sum + quantity, 0);
    } else {
      lines.push({
        key: key,
        id: detail.id,
        article: detail.article,
        name: detail.name,
        color: detail.color,
        image: detail.image,
        price: typeof detail.price === 'number' ? detail.price : (detail.price ? Number(detail.price) : null),
        sizes: Object.assign({}, detail.sizes),
        variantIds: Object.assign({}, detail.variantIds || {}),
        variantSkus: Object.assign({}, detail.variantSkus || {}),
        total: detail.total
      });
    }
    save();
    renderLines();
    updateBadge();
  }

  function makeReference() {
    const now = new Date();
    const pad = value => String(value).padStart(2, '0');
    const stamp = String(now.getFullYear()) + pad(now.getMonth() + 1) + pad(now.getDate());
    return 'SM-' + stamp + '-' + String(Math.floor(Math.random() * 9000) + 1000);
  }

  function setReturnPath(token) {
    const input = form.querySelector('[name="return_to"]');
    if (!input) return;
    const url = new URL(window.location.href);
    url.searchParams.set('smg_return', token);
    const previewId = view.dataset.previewThemeId;
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    else url.searchParams.delete('preview_theme_id');
    url.hash = 'bestelling-ontvangen';
    input.value = url.pathname + url.search + url.hash;
  }

  function pieceLabel(quantity) {
    return quantity + (quantity === 1 ? ' stuk' : ' stuks');
  }

  function orderText(reference) {
    const total = priceTotal();
    const articleCount = lines.length + (lines.length === 1 ? ' artikel' : ' artikelen');
    const headline = [articleCount, pieceLabel(pieces())];
    if (total !== null) headline.push(money(total) + ' excl. btw');
    const out = ['BESTELDE ARTIKELEN', headline.join(' · '), ''];

    lines.forEach((line, index) => {
      out.push((index + 1) + '. ' + line.name);
      out.push(line.article + ' · ' + line.color);
      if (isFixedPack(line)) out.push((line.total / packFor(line).count) + ' pakketten van ' + packFor(line).count + ' stuks · per pakket ' + packFor(line).ratio);
      Object.entries(line.sizes).forEach(([size, quantity]) => {
        out.push(size + ' · ' + pieceLabel(quantity));
        if (line.variantSkus && line.variantSkus[size]) out.push('SKU: ' + line.variantSkus[size]);
      });
      if (typeof line.price === 'number') {
        out.push(money(line.price) + ' per stuk excl. btw · subtotaal ' + money(line.price * line.total) + ' excl. btw');
      } else {
        out.push('Subtotaal: ' + line.total + ' stuks');
      }
      out.push('');
    });
    out.push('TOTAAL EXCL. BTW');
    out.push(pieceLabel(pieces()) + (total !== null ? ' · ' + money(total) + ' excl. btw' : ''));
    out.push('');
    out.push('Beschikbaarheid wordt gecontroleerd voordat de bestelling definitief wordt bevestigd.');
    return out.join('\n');
  }

  function renderDoneSummary(orderLines) {
    const fragment = document.createDocumentFragment();
    let totalPieces = 0;
    let totalPrice = 0;
    let hasPrices = true;

    orderLines.forEach(line => {
      const item = node('article', 'smg-order-card');
      const photo = node('div', 'smg-order-card__photo');
      if (line.image) {
        const image = document.createElement('img');
        image.src = line.image;
        image.alt = line.name + ' · ' + line.color;
        image.width = 112;
        image.height = 140;
        image.loading = 'lazy';
        photo.append(image);
      }

      const body = node('div', 'smg-order-card__body');
      body.append(node('h3', '', line.name));
      body.append(node('p', 'smg-order-card__meta', line.article + ' · ' + line.color));

      const sizes = node('ul', 'smg-order-card__sizes');
      Object.entries(line.sizes).forEach(([size, quantity]) => {
        const sizeLine = node('li');
        const sizeName = node('span', '', 'Maat ' + size);
        const amount = node('strong', '', pieceLabel(quantity));
        sizeLine.append(sizeName, amount);
        if (line.variantSkus && line.variantSkus[size]) {
          sizeLine.append(node('small', '', line.variantSkus[size]));
        }
        sizes.append(sizeLine);
      });
      body.append(sizes);

      const footer = node('div', 'smg-order-card__price');
      if (typeof line.price === 'number') {
        footer.append(
          node('span', '', money(line.price) + ' per stuk excl. btw'),
          node('strong', '', money(line.price * line.total) + ' excl. btw')
        );
        totalPrice += line.price * line.total;
      } else {
        footer.append(node('span', '', line.total + ' stuks'));
        hasPrices = false;
      }
      body.append(footer);
      item.append(photo, body);
      fragment.append(item);
      totalPieces += line.total;
    });

    byId('smg-cart-done-items').replaceChildren(fragment);
    byId('smg-cart-done-count').textContent = orderLines.length + (orderLines.length === 1 ? ' artikel' : ' artikelen');
    byId('smg-cart-done-pieces').textContent = pieceLabel(totalPieces);
    byId('smg-cart-done-total-row').hidden = !hasPrices;
    if (hasPrices) byId('smg-cart-done-total').textContent = money(totalPrice);
  }

  function showDone(reference, summary, clearCart = true, orderLines = lines) {
    const savedLines = JSON.parse(JSON.stringify(orderLines || []));
    const url = new URL(window.location.href);
    url.searchParams.delete('smg_return');
    url.searchParams.delete('contact_posted');
    url.hash = 'bestelling-ontvangen';
    window.history.replaceState(null, '', url);
    view.hidden = false;
    ['b2b-collection', 'b2b-product'].forEach(id => { if (byId(id)) byId(id).hidden = true; });
    try { window.sessionStorage.setItem(DONE_KEY, JSON.stringify({reference, summary, orderLines:savedLines, demo: isDemo, createdAt: Date.now()})); } catch {}

    byId('smg-cart-ref').textContent = reference;
    byId('smg-cart-done-summary').textContent = summary;
    renderDoneSummary(savedLines);
    byId('smg-cart-done-intro').textContent = isDemo
      ? 'Dit is een ontwerpvoorbeeld. Er is geen bestelling verstuurd en je ontvangt geen e-mail.'
      : 'Bedankt. We hebben je bestelling ontvangen. We controleren de beschikbaarheid en nemen daarna contact met je op. Je bestelling is definitief zodra Sophie & Me deze heeft bevestigd.';
    byId('smg-cart-main').hidden = true;
    byId('smg-cart-done').hidden = false;
    if (clearCart) {
      lines = [];
      save();
    }
    renderLines();
    updateBadge();
    window.scrollTo({top: 0, behavior: 'instant'});
    byId('smg-cart-done-title').focus({preventScroll: true});
  }
  function showFailure(reference, summary, challenged) {
    const button = byId('smg-cart-submit');
    button.disabled = false;
    button.textContent = 'Bestelling versturen →';
    byId('smg-cart-status').textContent = challenged
      ? 'De verzending werd onderbroken door een beveiligingscontrole. Stuur je bestelling per e-mail, dan pakken wij hem direct op.'
      : 'Versturen is niet gelukt. Probeer het opnieuw of stuur je bestelling per e-mail.';
    const mail = byId('smg-cart-mailto');
    mail.href = 'mailto:webshop@sophie-me.nl?subject=' + encodeURIComponent('Bestelling ' + reference) + '&body=' + encodeURIComponent(summary);
    mail.hidden = false;
  }

  function rememberPending(reference, summary, token) {
    try {
      const pending = {reference, summary, token, createdAt: Date.now(), cart: JSON.stringify(lines)};
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
      return window.sessionStorage.getItem(PENDING_KEY) === JSON.stringify(pending);
    } catch { return false; }
  }

  function readPending() {
    try {
      const pending = JSON.parse(window.sessionStorage.getItem(PENDING_KEY));
      return pending && pending.reference && pending.summary && pending.token && Date.now() - pending.createdAt < 7200000 ? pending : null;
    } catch {
      return null;
    }
  }

  function clearPending() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch {
      /* Geen actie nodig als sessieopslag niet beschikbaar is. */
    }
  }

  function submit(event) {
    if (submitting || !lines.length || !lines.every(validFixedPack) || !updateMinimum() || !form.reportValidity()) {
      event.preventDefault();
      return;
    }

    const reference = makeReference();
    const summary = orderText(reference);
    form.querySelector('[name="contact[Bestelnummer]"]').value = reference;
    form.querySelector('[name="contact[body]"]').value = summary;
    const token = window.crypto.randomUUID();
    setReturnPath(token);

    const button = byId('smg-cart-submit');
    byId('smg-cart-status').textContent = '';
    byId('smg-cart-mailto').hidden = true;

    if (isDemo) {
      event.preventDefault();
      submitting = true;
      button.disabled = true;
      button.textContent = 'Versturen…';
      const orderLines = JSON.parse(JSON.stringify(lines));
      window.setTimeout(() => showDone(reference, summary, true, orderLines), 250);
      return;
    }

    if (!rememberPending(reference, summary, token)) {
      event.preventDefault();
      byId('smg-cart-status').textContent = 'Je browser kan de bestelling niet tijdelijk bewaren. Open de webshop in Safari of Chrome en probeer opnieuw. Er is niets verstuurd.';
      return;
    }
    submitting = true;
    button.disabled = true;
    button.textContent = 'Versturen…';
  }

  byId('smg-cart-lines').addEventListener('click', event => {
    const button = event.target.closest('[data-remove]');
    if (!button) return;
    lines = lines.filter(line => line.key !== button.dataset.remove);
    save();
    renderLines();
    updateBadge();
  });

  byId('smg-cart-lines').addEventListener('input', event => {
    const input = event.target.closest('[data-quantity-key][data-quantity-size]');
    if (!input) return;
    if (input.value === '') return;
    const line = lines.find(item => item.key === input.dataset.quantityKey);
    const quantity = Number(input.value);
    if (!line || !Number.isInteger(quantity) || quantity < 0 || quantity > 999) {
      renderLines();
      return;
    }
    if (isFixedPack(line)) {
      if (input.dataset.quantitySize !== '__pack' || quantity > Math.floor(999 / Math.max(...Object.values(packFor(line).sizes)))) { renderLines(); return; }
      line.sizes = quantity === 0 ? {} : Object.fromEntries(Object.entries(packFor(line).sizes).map(([size, count]) => [size, quantity * count]));
    } else if (quantity === 0) delete line.sizes[input.dataset.quantitySize];
    else line.sizes[input.dataset.quantitySize] = quantity;
    line.total = Object.values(line.sizes).reduce((sum, value) => sum + value, 0);
    if (line.total === 0) lines = lines.filter(item => item.key !== line.key);
    save();
    renderLines();
    updateBadge();
  });

  const printButton = byId('smg-cart-print');
  if (printButton) printButton.addEventListener('click', () => {
    if (byId('smg-cart-done').hidden) return;
    document.body.classList.add('smg-print-order');
    byId('smg-cart-done').querySelector('details').open = true;
    window.print();
  });
  window.addEventListener('beforeprint', () => {
    if (!byId('smg-cart-done').hidden) document.body.classList.add('smg-print-order');
  });
  window.addEventListener('afterprint', () => document.body.classList.remove('smg-print-order'));

  byId('smg-cart-copy').addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(byId('smg-cart-done-summary').textContent);
      byId('smg-cart-copy-status').textContent = 'Bestelling gekopieerd.';
    } catch {
      byId('smg-cart-copy-status').textContent = 'Kopiëren lukte niet. Open “Bekijk je bestelling” en selecteer de tekst.';
    }
  });

  document.addEventListener('smg:add-to-cart', event => add(event.detail));
  document.addEventListener('smg:cart-open', () => {
    if (window.location.hash === '#bestelling-ontvangen' && !byId('smg-cart-done').hidden) return;
    submitting = false;
    byId('smg-cart-submit').disabled = false;
    byId('smg-cart-submit').textContent = 'Bestelling plaatsen →';
    updateMinimum();
    byId('smg-cart-main').hidden = false;
    byId('smg-cart-done').hidden = true;
    renderLines();
    updateBadge();
    byId('smg-cart-title').focus({preventScroll: true});
  });
  if (form) form.addEventListener('submit', submit);

  renderLines();
  if (removedSoldOut) byId('smg-cart-status').textContent = 'SM-006 is uitverkocht en uit je winkelwagen verwijderd.';
  if (removedLoosePacks) byId('smg-cart-status').textContent = 'Dit artikel wordt uitsluitend per pakket verkocht. De eerdere losse aantallen zijn verwijderd; voeg het gewenste aantal pakketten opnieuw toe.';

  const pending = readPending();
  const returnUrl = new URL(window.location.href);
  const tokenMatches = pending && returnUrl.searchParams.get('smg_return') === pending.token;
  const hasErrors = formState && formState.dataset.hasErrors === 'true';
  const shopifySuccess = formState && formState.dataset.postedSuccessfully === 'true';
  if (!isDemo && !hasErrors && pending && (shopifySuccess || tokenMatches)) {
    const cartUnchanged = pending.cart === JSON.stringify(lines);
    clearPending();
    let orderLines = [];
    try { orderLines = JSON.parse(pending.cart); } catch {}
    showDone(pending.reference, pending.summary, cartUnchanged, orderLines);
  } else if (window.location.hash === '#bestelling-ontvangen') {
    let done;
    try { done = JSON.parse(window.sessionStorage.getItem(DONE_KEY)); } catch {}
    if (!hasErrors && !returnUrl.searchParams.has('smg_return') && done && done.demo === isDemo && Date.now() - done.createdAt < 7200000) {
      showDone(done.reference, done.summary, false, done.orderLines || []);
    } else {
      returnUrl.searchParams.delete('smg_return');
      returnUrl.hash = 'winkelwagen';
      window.history.replaceState(null, '', returnUrl);
      byId('smg-cart-status').textContent = 'De verzending kon niet worden bevestigd. Je winkelwagen is bewaard. Controleer eerst of Sophie & Me de bestelling heeft ontvangen voordat je opnieuw verstuurt.';
    }
  }
  if (hasErrors) {
    clearPending();
    byId('smg-cart-status').textContent = 'De bestelling is niet verstuurd. Controleer de ingevulde gegevens. Je winkelwagen is bewaard.';
  }
  window.addEventListener('pageshow', () => {
    submitting = false;
    byId('smg-cart-submit').disabled = false;
    byId('smg-cart-submit').textContent = 'Bestelling plaatsen →';
    updateMinimum();
  });
})();

